import { supabase } from "./supabase";
import type { Session, User } from "@supabase/supabase-js";

export async function signUpWithEmail(email: string, password: string, metadata?: Record<string, any>) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      emailRedirectTo: `${window.location.origin}/coming-soon`,
      data: metadata,
    },
  });
  if (error) throw error;
  return data;
}

export async function signInWithEmail(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  if (error) throw error;
  return data;
}

export async function signInWithGoogle() {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: `${window.location.origin}/coming-soon`,
    },
  });
  if (error) throw error;
  return data;
}

export async function signInWithGitHub() {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: "github",
    options: {
      redirectTo: `${window.location.origin}/coming-soon`,
    },
  });
  if (error) throw error;
  return data;
}

export async function signOut() {
  if (import.meta.env.DEV) {
    localStorage.removeItem("dev_bypass_user");
  }
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export async function getActiveSession(): Promise<Session | null> {
  if (import.meta.env.DEV) {
    const bypassStr = localStorage.getItem("dev_bypass_user");
    if (bypassStr) {
      const devUser = JSON.parse(bypassStr);
      return {
        access_token: "mock-dev-token",
        token_type: "bearer",
        expires_in: 3600,
        refresh_token: "mock-dev-refresh",
        user: {
          id: devUser.id,
          aud: "authenticated",
          role: "authenticated",
          email: devUser.email,
          email_confirmed_at: "2026-07-18T00:00:00Z",
          user_metadata: { full_name: devUser.name },
          app_metadata: {},
          created_at: new Date().toISOString(),
        } as any
      };
    }
  }

  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) throw error;
  return session;
}

export async function getActiveUser(): Promise<User | null> {
  if (import.meta.env.DEV) {
    const bypassStr = localStorage.getItem("dev_bypass_user");
    if (bypassStr) {
      const devUser = JSON.parse(bypassStr);
      return {
        id: devUser.id,
        aud: "authenticated",
        role: "authenticated",
        email: devUser.email,
        email_confirmed_at: "2026-07-18T00:00:00Z",
        user_metadata: { full_name: devUser.name },
        app_metadata: {},
        created_at: new Date().toISOString(),
      } as any;
    }
  }

  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  return user;
}

export function onAuthStateChange(
  callback: (event: string, session: Session | null) => void
) {
  const { data: { subscription } } = supabase.auth.onAuthStateChange(callback);
  return subscription;
}
